import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 0.17648rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  padding: 1.875rem;
  width: 27.5rem;
  max-width: 27.5rem;
`;

export const AccountableUsers = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 3rem;
  height: 3.5rem;
  //background-color: red;
`;

export const HeaderTitle = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  color: #585e66;
`;

export const AddUser = styled.div`
  height: 1.759167rem;
  display: flex;
  align-items: center;
`;

export const AddUserTitle = styled.span`
  font-size: 0.704167rem;
  color: #42464c;
  font-weight: 600;
  line-height: 0.63rem;
  margin-left: 0.3rem;
  cursor: pointer;
`;

export const ActualUser = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  span {
    font-size: 0.75rem;
    font-weight: 600;
    color: #42464c;
    margin-left: 0.5rem;
  }
`;

export const CloseDiv = styled.div`
  svg {
    width: 0.75rem;
    height: 0.75rem;
    cursor: pointer;
    margin-left: 0.5rem;
  }

  &:hover {
    path {
      stroke: #40e5a0;
    }
  }
`;
export const Avatar = styled.div`
  width: 1.875rem;
  height: 1.875rem;
  background: lightblue;
  border-radius: 50%;
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  margin-bottom: 1.31875rem;
`;

export const SubTitle = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.125rem;
  margin-bottom: 1.13875rem;

  color: #585e66;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 3rem;
`;

export const DivIcon = styled.div`
  position: absolute;
  top: 1.125rem;
  right: 0.9375rem;
  cursor: pointer;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    &:hover {
      path,
      rect {
        stroke: #40e5a0;
      }
    }
  }
`;
